import {Celebrity} from "../models/celebrity/celebrity";

export class CelebrityHelper {
    static formatCelebrityName(celebrity: Celebrity) {
        return celebrity?.group ? celebrity.fullName + ' (' + celebrity.group + ')' : celebrity.fullName;
    }
}